import { apiClient } from '../../../api/httpClient';

export const getCurrentUser = () => (
  apiClient.get('/user')
);

export const getDsaReportsContracts = () => (
  apiClient.get('/dsa-reports/contracts')
);

export const getDsaReportsCompanies = () => (
  apiClient.get('/dsa-reports/companies')
);

export const getDsaReportsIssues = ({ companyId, startDate, endDate }) => (
  apiClient.get('/dsa-reports/issues', {
    params: {
      companyId,
      start_date: startDate,
      end_date: endDate,
    },
  })
);

export const getDsaReportsIssuesById = ({ issueId }) => (
  apiClient.get('/dsa-reports/issues', {
    params: { issueId },
  })
);

export const getDsaReportsPeriods = ({ contractId, startDate, endDate }) => (
  apiClient.get('/dsa-reports/periods', {
    params: { contractId, startDate, endDate },
  })
);

export const getDsaReportsActivities = ({
  againstType,
  againstId,
  dateModifiedAfter,
  dateModifiedBefore,
}) => (
  apiClient.get('/dsa-reports/activities', {
    params: {
      againstType,
      againstId,
      date_modified_after: dateModifiedAfter,
      date_modified_before: dateModifiedBefore,
    },
  })
);

export const getDsaReportsJobs = ({ jobId }) => (
  apiClient.get('/dsa-reports/jobs', {
    params: { jobId },
  })
);

export const getDsaReportsMilestones = ({ milestoneId }) => (
  apiClient.get('/dsa-reports/milestones', {
    params: { milestoneId },
  })
);
